<footer class="footer">

  <!--
  <div class="footer__links">
    <button
      type="button"
      class="footer__link"
      (click)="openPrivacyPolicyDialog()">
      {{ 'footer.links.privacy' | translate }}
    </button>

    <button
      type="button"
      class="footer__link"
      (click)="openLegalNoticeDialog()">
      {{ 'footer.links.legal' | translate }}
    </button>

    <button
      type="button"
      class="footer__link"
      (click)="openTermsAndConditionsDialog()">
      {{ 'footer.links.terms' | translate }}
    </button>
  </div>
  -->

  <div class="footer__logos">
    <img class="footer__logo" src="assets/footer/footer-1.png" alt="JRS Hungary" />
    <img class="footer__logo" src="assets/footer/footer-2.png" alt="JRS Romania" />
    <img class="footer__logo" src="assets/footer/footer-3.png" alt="Centrum Pomoci pre Rodinu" />
    <img class="footer__logo" src="assets/footer/footer-4.png" alt="ASSWR" />
    <img class="footer__logo" src="assets/footer/footer-5.png" alt="Evangélikus Diakónia" />
    <img class="footer__logo" src="assets/footer/footer-6.png" alt="Lifestarter" />
    <img class="footer__logo" src="assets/footer/footer-7.png" alt="Personal Service" />
    <img class="footer__logo" src="assets/footer/footer-8.png" alt="Szociometrum" />
    <img class="footer__logo" src="assets/footer/footer-9.png" alt="Universitas Tyrnaviensis" />
  </div>

  <p class="footer__disclaimer">{{ 'footer.euDisclaimer' | translate }}</p>

  <button
    type="button"
    class="footer__privacy-link"
    (click)="openPrivacyPolicyDialog()">
    {{ 'footer.links.privacy' | translate }}
  </button>

</footer>
